// extracted by mini-css-extract-plugin
export default {"quiz_header":"aw","quiz_header_wrapper":"bw","header_button":"cw","hidden":"ew","gainful_logo":"fw","MyClassEnterDone":"gw","x_button":"hw","logoWrapper":"iw","logoWrapperMob":"jw"};
    if(module.hot) {
      // 1711717533150
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  